<template>
  <div class="pa-4">
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn small elevation="0" @click="displayAddDialog()" color="primary" outlined>
        <v-icon>mdi-text-box-plus-outline</v-icon>
        <span class="ml-1 hidden-sm-and-down">{{ $t('message.add_class_notes') }}</span>
      </v-btn>
    </v-card-actions>
    <v-card class="bjjlink-card" elevation="0" outlined>
      <v-card-text>
        <v-select outlined dense :label="$t('message.filter_by_user')" :items="admins" item-text="text" item-value="_id"
          v-model="userFilter" clearable></v-select>
        <v-select outlined dense :label="$t('message.filter_by_tag')" :items="loadedTags" v-model="tagFilter"
          clearable></v-select>
        <div class="text-subtitle-1">{{ $t('message.date_before') }}:</div>
        <DatePicker :show-time="false" v-if="dateFilter" v-model="dateFilter" :allow-all-dates="true">
        </DatePicker>
        <v-switch hide-details v-model="claFilter" :label="$t('message.cla_long')"></v-switch>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small elevation="0" @click="clearFilters()">
          <v-icon>mdi-delete-outline</v-icon>
          <span class="ml-1 hidden-sm-and-down">{{ $t('message.clear_filters') }}</span>
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-expansion-panels class="bjjlink-card" flat>
      <v-expansion-panel :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'"
        v-for="(n, index) in notes" :key="index + n._id" fill-height style="margin-bottom:5px" elevation="0" outlined>
        <v-expansion-panel-header @click="loadRestrictionLists()">
          <div>
            <v-icon color="primary" size="20" v-if="n.public">mdi-earth</v-icon>
            <v-icon color="gray" size="20" v-else>mdi-earth</v-icon>
            <span v-if="!isSmallerDisplay() && n.user">{{ n.user.fName }} {{ n.user.lName }} - {{ n.title }}</span>
            <span v-else-if="n.user">{{ truncate(n.user.fName + ' ' + n.user.lName, 10) }} - {{ truncate(n.title, 20)
              }}</span>
            <div class="pt-2 supporting-text">
              <div v-if="n.video">
                <v-icon color="primary" size="20" class="mr-1">mdi-video-outline</v-icon>
                {{ $d(dateFromString(n.date), 'month_day_year', $i18n.locale) }}
              </div>
              <div v-else-if="n.videoLink">
                <v-icon color="primary" size="20" class="mr-1">mdi-link</v-icon>
                {{ $d(dateFromString(n.date), 'month_day_year', $i18n.locale) }}
              </div>
              <div v-else-if="n.flowchart">
                <v-icon color="primary" size="20" class="mr-1">mdi-sitemap-outline</v-icon>
                {{ $d(dateFromString(n.date), 'month_day_year', $i18n.locale) }}
              </div>
              <div v-else class="pl-5">
                {{ $d(dateFromString(n.date), 'month_day_year', $i18n.locale) }}
              </div>
            </div>
            <div v-if="n.cla" class="pt-2 supporting-text">
              <v-icon size="20" class="mr-1">mdi-gamepad-variant-outline</v-icon>
              {{ $t('message.cla_long') }}
            </div>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content v-if="n.date">
          <v-divider></v-divider>
          <v-card-text v-if="n.public" class="supporting-text pa-1" style="font-size: 1em">
            <v-icon>mdi-earth</v-icon>
            {{ $t('message.public_notes') }}
          </v-card-text>
          <v-card-text v-if="n.academyClass" class="supporting-text pa-1" style="font-size: 1em">
            <v-icon>mdi-calendar-outline</v-icon>
            {{ $t('message.linked_class') }}: {{ n.academyClass.title }}
            <v-btn icon small
              @click="navigateTo({ name: 'manageacademyclass', params: { academyClassId: n.academyClass._id } })">
              <v-icon>mdi-arrow-right-bold-circle-outline</v-icon>
            </v-btn>
          </v-card-text>
          <v-card-text v-if="n.flowchart" class="supporting-text pa-1" style="font-size: 1em">
            <v-icon>mdi-sitemap-outline</v-icon>
            {{ $t('message.flowchart') }}: {{ n.flowchart.name }}
            <v-btn icon small
              @click="navigateTo({ name: 'manageflowchart', params: { flowchartId: n.flowchart._id } })">
              <v-icon>mdi-arrow-right-bold-circle-outline</v-icon>
            </v-btn>
          </v-card-text>
          <v-card-text v-if="n.tags && n.tags.length > 0" class="pa-1 mb-2">
            <v-icon>mdi-label-outline</v-icon>
            <span class="mr-2">{{ $t('message.tags') }}:</span>
            <template v-for="(t, index2) in n.tags">
              <v-chip small class="mr-1" :key="n._id + 'tag' + index2">{{ t }}</v-chip>
            </template>
          </v-card-text>
          <v-card-text v-if="n.restricted" class="pa-1 mb-2">
            <v-icon>mdi-eye-outline</v-icon>
            {{ $t('message.restricted') }}:
            <div
              v-if="!n.visbilityTags || n.visbilityTags.length == 0 || !n.visbilityUsers || n.visbilityUsers.length == 0">
              {{ $t('message.no_visibility_rules') }}
            </div>
            <div v-if="n.visbilityTags && n.visbilityTags.length > 0">
              <template v-for="(t, index2) in n.visbilityTags">
                <v-chip class="mr-1" :key="n._id + 'vtag' + index2">{{ t }}</v-chip>
              </template>
            </div>
            <div v-if="n.visbilityUsers && n.visbilityUsers.length > 0" class="mt-1">
              <template v-for="(u, index2) in n.visbilityUsers">
                <v-chip class="mr-1" :key="u._id + 'utag' + index2">
                  <v-avatar size="15" v-if="u.userImageSmall">
                    <ImageDisplay :src="u.userImageSmall" />
                  </v-avatar>
                  {{ u.displayName }}
                </v-chip>
              </template>
            </div>
          </v-card-text>
          <v-card-text v-html="n.notes" class="page-description"></v-card-text>
          <v-responsive v-if="n.video && n.video.ready">
            <v-card-text class="pa-1 clickable" style="font-size: 1em" @click="goToVideo(n.video._id)">
              <v-icon>mdi-video-outline</v-icon>{{ n.video.title }}</v-card-text>
            <video-display style="max-height:300px" :video="n.video"></video-display>
          </v-responsive>
          <v-responsive v-else-if="n.videoLink" class="text-center">
            <iframe v-if="getYouTubeId(n.videoLink)" width="560" height="315"
              :src="'https://www.youtube.com/embed/' + getYouTubeId(n.videoLink)" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen></iframe>
            <span v-else>{{ n.videoLink }}</span>
          </v-responsive>
          <v-card-actions>
            <div v-if="n.updatedBy">
              <v-avatar size="20">
                <ImageDisplay v-if="n.updatedBy.userImageSmall" :src="n.updatedBy.userImageSmall" />
                <img v-else :src="assets('default-profile-avatar.png')" />
              </v-avatar>
              <span style="margin-left:5px">{{ $t('message.last_update_by') }} {{ n.updatedBy.displayName }}</span>
              <span style="color:gray; margin-left: 10px">{{ $d(new Date(n.updatedOn), 'month_day_year', $i18n.locale)
                }}</span>
            </div>
            <v-spacer></v-spacer>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" fab text small slot="activator" left>
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click.stop="displayUpdateDialog(n)">
                  <v-list-item-title>{{ $t('message.edit') }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click.stop="displayDeleteDialog(n._id)">
                  <v-list-item-title>{{ $t('message.delete') }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-card-actions>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div v-if="loading">
      <v-skeleton-loader
        type="list-item-avatar, divider, list-item-avatar, divider, list-item-avatar"></v-skeleton-loader>
    </div>
    <div v-if="viewMore">
      <v-btn color="primary" @click="getClassNotes(true)">{{ $t('message.view_more') }}</v-btn>
    </div>
    <v-dialog v-model="addJournalDialog" max-width="90%">
      <v-card v-if="currentToEdit">
        <v-card-text>
          <h2 class="mt-4">{{ $t('message.add_notes') }}</h2>
        </v-card-text>
        <v-card-text class="error" style="color:white" v-if="addNotesError">{{ $t('message.fill_all_params')
          }}</v-card-text>
        <v-card-text>
          <v-text-field outlined dense v-model="currentToEdit.title" :label="$t('message.title')"
            required></v-text-field>
          <v-combobox :items="loadedTags" v-model="currentToEdit.tags" :search-input.sync="search" small-chips
            :label="$t('message.tags')" multiple outlined dense>
            <template slot="no-data">
              <v-list-item>
                <span class="subheading">{{ $t('message.click_enter_add_new') }}:</span>
                <v-chip label small>{{ search }}</v-chip>
              </v-list-item>
            </template>
          </v-combobox>
          <v-switch hide-details v-model="currentToEdit.public" :label="$t('message.visibale_notes')"></v-switch>
          <v-switch v-model="currentToEdit.cla" :label="$t('message.cla_long')"></v-switch>
          <div class="text-subtitle-1">{{ $t('message.date') }}</div>
          <DatePicker :show-time="false" v-if="selectedDate" v-model="selectedDate" :allow-all-dates="true">
          </DatePicker>
          <v-autocomplete :label="$t('message.link_to_class')" :items="academyClasses" item-text="text"
            item-value="value" v-model="currentToEdit.academyClass" clearable outlined dense></v-autocomplete>
          <v-textarea outlined dense :label="$t('message.notes')" v-model="currentToEdit.notes"></v-textarea>
          <v-select dense outlined :label="$t('message.add_extra_content')" :items="extraContentOptions"
            v-model="extraContent"></v-select>
          <div v-if="extraContent == 'video'">
            <v-autocomplete :label="$t('message.notes_video')" :items="videos" item-text="title" item-value="_id"
              v-model="currentToEdit.video" hide-details clearable outlined dense></v-autocomplete>
          </div>
          <div v-else-if="extraContent == 'link'">
            <v-text-field outlined dense :label="$t('message.notes_video_link')" v-model="currentToEdit.videoLink">
            </v-text-field>
          </div>
          <div v-else-if="extraContent == 'flowchart'">
            <FlowchartsSelect v-model="currentToEdit.flowchart"></FlowchartsSelect>
          </div>
          <v-switch @change="loadRestrictionLists" v-if="currentToEdit.public" hide-details
            :label="$t('message.restricted')" v-model="currentToEdit.restricted">
          </v-switch>
          <v-card v-if="currentToEdit.restricted" outlined class="pa-0">
            <div class="text-caption mb-2">{{ $t('message.restricted_notes_explained') }}</div>
            <div>
              <v-autocomplete multiple :loading="loadingMembers" v-model="selectedMembers" :items="members"
                :label="$t('message.select_members')" item-text="text" item-value="value" clearable outlined
                dense></v-autocomplete>

              <v-autocomplete multiple :loading="loadingTags" v-model="selectedTags" :items="availableTags"
                :label="$t('message.select_member_tags')" clearable outlined dense></v-autocomplete>
            </div>
          </v-card>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined small color="primary" @click.stop="addNotes()">{{ $t('message.save') }}</v-btn>
          <v-btn small depressed class="outlined-btn" @click.stop="closeAddNotesDialog()">{{ $t('message.close')
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteAddNotesDialog" max-width="500px">
      <v-card>
        <v-card-text>
          <div class="text-subtitle-1">{{ $t('message.remove_notes') }}</div>
        </v-card-text>
        <v-card-actions>
          <v-btn elevation="0" color="error" @click.stop="deleteNotes()">{{ $t('message.delete') }}</v-btn>
          <v-btn elevation="0" class="outlined-btn" @click.stop="closeDeleteNotesDialog()">{{ $t('message.close')
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VideoDisplay from "@/components/displays/VideoDisplay.vue";
import DatePicker from "@/components/inputs/DateTimePicker.vue";
import FlowchartsSelect from "@/components/inputs/FlowchartsSelect.vue";
import Api from "@/services/Api";

export default {
  data() {
    return {
      loading: false,
      addJournalDialog: false,
      deleteAddNotesDialog: false,
      currentToEdit: null,
      selectedDate: null,
      dateMenu: null,
      loadedTags: [],
      className: null,
      classNames: [],
      admins: [],
      videos: [],
      search: null,
      addNotesError: false,
      searching: false,
      viewMore: false,
      notes: [],
      index: 0,
      toDelete: null,
      userFilter: null,
      tagFilter: null,
      classFilter: null,
      dateFilter: null,
      claFilter: false,
      maxSearchCount: 20,
      today: null,
      members: [],
      selectedMembers: [],
      loadingMembers: false,
      availableTags: [],
      loadingTags: false,
      selectedTags: [],
      extraContent: null,
      extraContentOptions: [
        { text: this.$t('message.none'), value: 'none' },
        { text: this.$t('message.notes_video'), value: 'video' },
        { text: this.$t('message.notes_video_link'), value: 'link' },
        { text: this.$t('message.flowchart'), value: 'flowchart' }
      ],
      academyClasses: []
    };
  },
  components: {
    VideoDisplay,
    DatePicker,
    FlowchartsSelect,
  },
  created() {
    const today = new Date();
    today.setHours(23);
    today.setMinutes(59);
    this.selectedDate = today;
    this.dateFilter = today;
    this.getAdmins();
    this.getTags();
    this.getClassNotes(false);
    this.getVideos();
    var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
    this.today = new Date(Date.now() - tzoffset).toISOString().slice(0, -1);
  },
  watch: {
    tagFilter: {
      handler: function () {
        this.getClassNotes(false);
      }
    },
    dateFilter: {
      handler: function (newValue) {
        let d = new Date(newValue);
        d.setHours(11);
        d.setMinutes(59);
        this.selectedDate = d;
        this.getClassNotes(false);
      }
    },
    userFilter: {
      handler: function () {
        this.getClassNotes(false);
      }
    },
    claFilter: {
      handler: function () {
        this.getClassNotes(false);
      }
    }
  },
  methods: {
    loadRestrictionLists() {
      this.loadMembers();
      this.getAvailableTags();
    },
    getAvailableTags() {
      this.loadingTags = true;
      Api()
        .get("admins/academy/" + this.$store.state.selectedAcademy + "/tags")
        .then((response) => {
          if (response.data) {
            this.availableTags = response.data.sort();
            this.loadingTags = false;
          }
        })
        .catch(() => {
          this.loadingTags = false;
        });
    },
    loadMembers() {
      this.loadingMembers = true;
      Api()
        .get("admins/academy/" + this.$store.state.selectedAcademy + "/members")
        .then((response) => {
          const data = response.data;
          if (data) {
            for (const m of data.approved) {
              this.members.push({ value: m._id, text: m.displayName });
            }
            this.loadingMembers = false;
          }
        }).catch(() => {
          this.loadingMembers = false;
        });
    },
    getYouTubeId(url) {
      if (url) {
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url.match(regExp);

        return (match && match[2].length === 11)
          ? match[2]
          : null;
      }
      return null;
    },
    getVideos() {
      Api()
        .get("videos/admins/" + this.$store.state.managedAcademy + '/titles/all')
        .then(response => {
          const data = response.data;
          if (data.videos && data.videos.length > 0) {
            this.videos = data.videos;
          }
        });
    },
    getTimezoneDay(date) {
      return new Date(date).toLocaleString("en-US", { timeZone: this.timeZone });
    },
    loadAcademyClasses() {
      Api()
        .get("calendar/admin/academy/" + this.$store.state.managedAcademy + "/events")
        .then(response => {
          if (response.data && response.data.events) {
            this.academyClasses = response.data.events.map(e => ({
              // Most classes here haven't been saved as an AcademyClass doc yet, so
              // there's no real id to use - fall back to a scheduleClassId+date blob
              // the backend can resolve (or create the class from) on save.
              value: e._id || e.id || JSON.stringify({ scheduleClassId: e.scheduleClassId, date: e.date || e.start }),
              text: e.title + ' (' + this.$d(new Date(e.date || e.start), 'month_day_year', this.$i18n.locale) + ')'
            }));
          }
        });
    },
    displayAddDialog() {
      this.addJournalDialog = true;
      this.currentToEdit = {
        managedAcademy: this.$store.state.managedAcademy,
      };
      let d = new Date();
      d.setHours(1);
      d.setMinutes(0);
      this.selectedDate = d;
      this.loadAcademyClasses();
    },
    closeAddNotesDialog() {
      this.addJournalDialog = false;
      this.currentToEdit = null;
      this.selectedDate = new Date();
    },
    displayDeleteDialog(id) {
      this.toDelete = id;
      this.deleteAddNotesDialog = true;
    },
    displayUpdateDialog(n) {
      this.selectedDate = new Date(n.date);
      this.currentToEdit = Object.assign({}, n);
      if (n.academyClass) this.currentToEdit.academyClass = n.academyClass._id;
      this.loadAcademyClasses();
      let tmp = [];
      if (n.visbilityUsers && n.visbilityUsers.length > 0) {
        for (const i of n.visbilityUsers)
          tmp.push(i._id);
        this.selectedMembers = tmp;
      }
      let tmp2 = [];
      if (n.visbilityTags && n.visbilityTags.length > 0) {
        for (const i of n.visbilityTags)
          tmp2.push(i);
        this.selectedTags = tmp2;
      }
      this.addJournalDialog = true;
    },
    closeDeleteNotesDialog() {
      this.deleteAddNotesDialog = false;
      this.currentToEdit = null;
    },
    deleteNotes() {
      Api()
        .delete("admins/academy/" + this.$store.state.selectedAcademy + "/classnotes/" + this.toDelete)
        .then(response => {
          if (response) {
            this.getClassNotes(false);
            this.toDelete = null;
            this.deleteAddNotesDialog = false;
          }
        })
        .catch(e => {
          if (e)
            this.showAlert("error", "Oops!", this.$t('message.error_generic'));
        });
    },
    updateClassNotes() {
      this.currentToEdit.date = this.selectedDate;
      if (!this.validateAddClassNotes()) {
        this.addNotesError = true;
        return false;
      } else {
        try {
          Api()
            .patch("admins/academy/" + this.$store.state.selectedAcademy + "/classnotes", this.currentToEdit)
            .then(response => {
              if (response)
                this.clearFilters();
            })
            .catch(e => {
              if (e)
                this.showAlert("error", "Oops!", this.$t('message.error_generic'));
            });
        } catch (err) {
          if (err)
            this.showAlert("error", "Oops!", this.$t('message.error_generic'));
        }
        this.addJournalDialog = false;
      }
    },
    addNotes() {
      this.index = 0;
      this.currentToEdit.date = this.selectedDate;
      if (this.selectedMembers.length > 0) {
        this.currentToEdit.visbilityUsers = this.selectedMembers;
      } else {
        this.currentToEdit.visbilityUsers = null;
      }
      if (this.selectedTags.length > 0) {
        this.currentToEdit.visbilityTags = this.selectedTags;
      } else {
        this.currentToEdit.visbilityTags = null;
      }
      if (this.currentToEdit._id) {
        this.updateClassNotes();
      } else {
        if (!this.validateAddClassNotes()) {
          this.addNotesError = true;
          return false;
        } else {
          this.addNotesError = false;
          Api()
            .post("admins/academy/" + this.$store.state.selectedAcademy + "/classnotes", this.currentToEdit)
            .then(response => {
              if (response)
                this.clearFilters();
            })
            .catch(e => {
              if (e)
                this.showAlert("error", "Oops!", this.$t('message.error_generic'));
            });
          this.addJournalDialog = false;
        }
      }
    },
    goToVideo(id) {
      this.navigateTo({ name: "managevideo", params: { videoId: id } });
    },
    validateAddClassNotes() {
      const h = this.currentToEdit;
      if (!h.date) return false;
      if (!h.title) return false;
      if (!h.notes) return false;
      return true;
    },
    getClassNames() {
      Api()
        .get("admins/academy/" + this.$store.state.selectedAcademy + "/classnames")
        .then(response => {
          var data = response.data;
          if (data) {
            this.classNames = data;
          }
        })
        .catch(e => {
          this.loading = false;
          if (e)
            this.showAlert("error", "Oops!", this.$t('message.error_generic'));
        });
    },
    getAdmins() {
      Api()
        .get("admins/academy/" + this.$store.state.managedAcademy + "/admins")
        .then(response => {
          var data = response.data;
          if (data) {
            if (data && data.length > 0) {
              var list = [];
              for (const a of data)
                list.push({ _id: a._id, text: a.fName + ' ' + a.lName })
              this.admins = list;
            }
          }
        })
        .catch(e => {
          this.loading = false;
          if (e)
            this.showAlert("error", "Oops!", this.$t('message.error_generic'));
        });
    },
    clearFilters() {
      const today = new Date();
      today.setHours(23);
      today.setMinutes(59);
      this.selectedDate = today;
      this.dateFilter = today;
      this.tagFilter = null;
      this.userFilter = null;
      this.selectedTags = [];
      this.selectedMembers = [];
      this.getClassNotes(false);
    },
    getClassNotes(append) {
      try {
        if (!this.searching) {
          this.searching = true;
          this.loading = true;
          this.viewMore = false;
          if (!append) {
            this.index = 0;
            this.notes = [];
          }
          let data = {};
          if (this.tagFilter) data.tags = [this.tagFilter];
          if (this.userFilter) data.user = this.userFilter;
          if (this.selectedDate) data.date = this.selectedDate;
          if (this.claFilter) data.cla = true;
          Api()
            .post("admins/academy/" + this.$store.state.selectedAcademy + "/classnotes/search?index=" + this.index, data)
            .then(response => {
              var data = response.data;
              if (data) {
                this.notes = this.notes.concat(data.notes);
                this.loading = false;
                this.index = this.index + data.count;
                if (data.count >= this.maxSearchCount) this.viewMore = true;
                this.searching = false;
              }
            })
            .catch(e => {
              this.loading = false;
              if (e)
                this.showAlert("error", "Oops!", this.$t('message.error_generic'));
            });
        }
      } catch (err) {
        if (err)
          this.showAlert("error", "Oops!", this.$t('message.error_generic'));
      }
    },
    getTags() {
      Api()
        .get("admins/academy/" + this.$store.state.selectedAcademy + "/classnotes/tags")
        .then(response => {
          this.loadedTags = response.data;
        })
        .catch(e => {
          if (e)
            this.showAlert("error", "Oops!", this.$t('message.error_generic'));
        });
    }
  }
};
</script>

<style scoped>
.notes_date {
  color: grey;
  margin-left: 15px;
}

.message_area {
  width: auto;
  background-color: #F8F8F8;
  border-radius: 10px 10px 10px 10px;
  font-size: 1.2em;
  margin-bottom: 5px;
  padding-top: 5px;
}

.hide-overflow {
  overflow-x: hidden;
}

.h-icon {
  margin-right: 6px;
}
</style>